import { render, staticRenderFns } from "./artefato-preview-card.vue?vue&type=template&id=6c955cba&scoped=true&"
import script from "./artefato-preview-card.vue?vue&type=script&lang=js&"
export * from "./artefato-preview-card.vue?vue&type=script&lang=js&"
import style0 from "./artefato-preview-card.vue?vue&type=style&index=0&id=6c955cba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c955cba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c955cba')) {
      api.createRecord('6c955cba', component.options)
    } else {
      api.reload('6c955cba', component.options)
    }
    module.hot.accept("./artefato-preview-card.vue?vue&type=template&id=6c955cba&scoped=true&", function () {
      api.rerender('6c955cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/ui-registry/artefato-preview-card.vue"
export default component.exports